<!-- pdf列表 -->
<template>
  <div class='pdfList'>
    <v-header id='header' :headTitle='headTitle' v-if='$route.query.source==0' :rightTitle='rightTitle' v-on:rightClick='rightClick' :isBack='true' ></v-header>
    <div class="van-box">
      <van-tabs @change='handleChangeTab' v-model="tabIndex" color='#26b4ff' title-active-color='#26B4FF'
          title-inactive-color='#666'>
        <van-tab title-style='font-size:16px;' title="视频"></van-tab>
        <van-tab title-style='font-size:16px;' title="课件"></van-tab>
      </van-tabs>
    </div>
    <div class="container">
      <div style="text-align:center;padding-top:20px;font-size:15px;color:#333;" v-if="tabIndex==0?videoListData.length==0:pdfListData.length==0">暂未上传</div>
      <div class="content" v-else>
        <div class="item df-item-center" :style='{"border-bottom":tabIndex==0&&index!=videoListData.length-1||tabIndex==1&&index!=pdfListData.length-1?"1px solid #eee":"","padding-bottom":tabIndex==0&&index!=videoListData.length-1||tabIndex==1&&index!=pdfListData.length-1?"30px":"50px"}' v-for='(item,index) in tabIndex==0?videoListData:pdfListData' :key='index'>
          <div class="item-left">
            <img v-if='tabIndex==0' src="../../assets/images/video-icon.png" alt="">
            <img v-if='tabIndex==1' src="../../assets/images/pdf-icon.png" alt="">
          </div>
          <div class="item-right">
            {{item.fileName}}
          </div>
          <div class="button-box df-center" v-if='tabIndex==0' :style='{"padding-bottom":index!=videoListData.length-1?"0px":"20px"}'>
            <span class='btn' @click='goPdfPreview(item)'>点击观看</span>
          </div>
          <div class="button-box df-center" v-if='tabIndex==1' :style='{"padding-bottom":index!=pdfListData.length-1?"0px":"20px"}'>
            <span class='btn' @click='goPdfPreview(item)'>预览</span>
            <div v-if='$route.query.source==0' class="line"></div>
            <span v-if='$route.query.source==0' class='btn' @click='handleDownFile(item)'>下载</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import header from '../../components/header/header'
  export default {
    data() {
      return {
        tabIndex:0,
        headTitle: '各角色上报操作指引',
        rightTitle: '分享',
        ListData:[],
        pdfListData:[],
        videoListData:[],
      }
    },
    components: {
      'v-header': header,
    },
    computed: {
      ...mapState({
        baseUrl: (state) => state._base
      }),
    },
    created() {
      this.tabIndex = parseInt(sessionStorage.getItem('tabNum'))?parseInt(sessionStorage.getItem('tabNum')):0
      document.title = this.headTitle
      this.initData()
    },
    methods: {
      handleChangeTab(){
        sessionStorage.setItem('tabNum',this.tabIndex)
      },
      // 获取pdf列表
      initData(){
        let params = {
          sub_id: "",
          data: {
            taskId:this.$route.query.taskId
          },
          malVersion: "A0"
        };
        this.$http.queryHandMonitoringReportFile(params).then((res) => {
          if (res.code === 0) {
            this.ListData = res.data
            this.ListData.forEach((v,i)=>{
              if(v.fileType==1){
                this.pdfListData.push(v)
              }else if(v.fileType==2){
                this.videoListData.push(v)
              }
            })
            if(this.videoListData.length == 0){
              this.tabIndex = 1
            }
          }
        });
      },
      // 分享
      rightClick() {
        let url = `${this.baseUrl}/handMonitorReported/#/pdfList?taskId=${this.$route.query.taskId}`
        // let url = `http://192.168.1.21:8088/#/pdfList`
        let title = this.headTitle
        let content = this.$route.query.batch + '年关于开展常态化疫情下医疗机构医务人员诊疗过程手卫生监测'
        console.log(url, '分享的url')
        try {
          uni.postMessage({
            data: {
              action: 'showShareView',
              data: {
                shareUrl: url,
                shareTitle: title,
                shareContent: content,
              }
            }
          });
          window.webkit.messageHandlers.showShareView.postMessage({
            shareUrl: url,
            shareTitle: title,
            shareContent: content,
          })
        } catch (err) {
          window.gk.showShareView(url, title, content)
        }
      },
      // 下载
      handleDownFile(val){
        try {
          uni.postMessage({
            data: {
              action: 'downLoad',
              data: {
                url:
                  val.fileUrl,
                reportId: '',
                rptTitleAlias: val.fileName,
                isDesensitization: '',
              }
            }
          });
          window.webkit.messageHandlers.downLoad.postMessage({
            url:
              val.fileUrl,
            reportId: '',
            rptTitleAlias: val.fileName,
            isDesensitization: '',
          })
        } catch (err) {
          window.gk.downLoad(
            val.fileUrl,
            '',
            val.fileName
          )
        }
      },
      // 预览
      goPdfPreview(val) {
        if(val.fileType==2){
          this.$router.push({
            path: '/videoPreview',
            query: {
              url: val.fileUrl,
              title: val.fileName,
              isShowPdfHead: '1',
              source: this.$route.query.source,
            },
          })

        }else{
          this.$router.push({
            path: '/pdfPreview',
            query: {
              url: val.fileUrl,
              title: val.fileName,
              isShowPdfHead: '1',
              source: this.$route.query.source,
            },
          })
        }
      },
    },
  }
</script>
<style lang='scss' scoped>
.pdfList{
   height: 100vh;
   display: flex;
   flex-direction: column;
  .van-box{
    border-bottom: 1px solid #eee;
  }
  .container{
    padding: 0px 12px;
    overflow: scroll;
    margin-bottom: 20px;
    h3{
      margin: 30px auto;
      font-size: 22px;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      color: #333333;
      text-align: center;
    }
    .content{
      margin: 30px 0px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 8px 0px rgba(81,116,143,0.10);
      .item{
        position: relative;
        padding: 20px 0px 30px 0px;
        margin: 0px 10px 0px 8px;
        // border-bottom: 1px solid #eee;
        .item-left{
          width: 70px;
          height: 70px;
          img{
            width: 100%;
            height: 100%;
          }

        }
        .item-right{
          flex: 1;
          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #333333;

        }
        .button-box{
          position: absolute;
          right: 0px;
          bottom: 0px;
          .btn{
            padding: 10px 0px;
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #26b4ff;
          }
          .line{
            margin: 0px 10px;
            width: 1px;
            height: 15px;
            background: #eeeeee;
          }

        }


      }
    }

  }

}
</style>